import { Box, SvgIcon, Typography } from "@mui/material";

import QubitLogo from "~/assets/img/QubitLogo.svg?react";

const LoginBranding = () => {
  return (
    <Box
      sx={{
        display: "inline-grid",
        gridTemplateColumns: "auto auto",
        gridTemplateRows: "auto auto",
        columnGap: 0.5,
        rowGap: { xs: "16px", md: "20px" },
        justifyItems: "center"
      }}
    >
      <SvgIcon
        component={QubitLogo}
        viewBox="0 0 64 64"
        color="secondary"
        sx={{
          display: "block",
          height: { xs: "6rem", md: "6.875rem" },
          width: { xs: "6rem", md: "6.875rem" }
        }}
      />

      <Typography
        fontWeight={500}
        lineHeight={1}
        sx={{
          fontSize: { xs: "2.5rem", md: "3.5rem" },
          gridRow: "2/3"
        }}
      >
        Qubit
      </Typography>

      <Typography
        fontWeight={500}
        sx={{
          gridRow: "2/3",
          gridColumn: "2/3",
          fontSize: { xs: "0.7rem", md: "0.875rem" },
          bottom: "5px",
          position: "relative"
        }}
      >
        TM
      </Typography>
    </Box>
  );
};

export default LoginBranding;
